<div class="searchBox" [ngClass]="{ ar: translate.currentLang == 'ar' }">
  <form
    [formGroup]="searchbox.searchFlight"
    [dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
  >
    <div class="container-fluid container-for-result">
      <div class="">
        <ng-container formArrayName="Flights">
          <div
            *ngFor="
              let item of searchbox.flightsArray['controls'];
              let i = index
            "
            class="row justify-content-start"
          >
            <ng-container [formGroupName]="i">
              <!-- Depart City web -->
              <div
                *ngIf="sharedService.screenWidth >= 650; else airportsDepartMobileView"
                class="col-12 col-md-12 col-lg-3 firstInput"
              >
                <mat-form-field
                  color="accent"
                  class="searchboxInput"
                  appearance="outline"
                >
                  <p
                    class="cityInputPlacholder"
                    [ngStyle]="{
                      color: searchbox.searchBoxValidation(i) ? 'red' : '',
                    }"
                  >
                    <ng-container *ngIf="searchbox.searchBoxValidation(i)"
                      >*</ng-container
                    >
                    {{ "searchbox.leaveFrom" | translate }}
                  </p>
                  <!-- Depart Input -->
                  <div class="d-flex">
                    <input
                      onClick="this.select();"
                      formControlName="departing"
                      type="text"
                      class="input"
                      aria-label="City"
                      matInput
                      [matAutocomplete]="autoa"
                      #firstD
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('departing')?.value
                          ? onCitySearch(item.get('departing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                    <i
                      class="bi bi-x closeIcon"
                      (click)="firstD.value = ' '; removeInput('depart', i)"
                    ></i>
                  </div>
                  <!-- Depart Airports -->
                  <mat-autocomplete #autoa="matAutocomplete">
                    <ng-container *ngIf="sharedService.cities != undefined">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('departing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        (onSelectionChange)="onSelectDepartingCity(city, i)"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                      >
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportName
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        -
                        <span
                          [innerHTML]="
                            city[sharedService.lang].countryName
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        (
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportCode
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        )
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </mat-form-field>
                <!-- Switch Arrow -->
                <div
                  class="switchArrow"
                  (click)="searchbox.switchDestination(item, i)"
                >
                  <img src="../../../../assets/icons/SwitchIcon.svg" />
                </div>
              </div>
              <ng-template #airportsDepartMobileView>
                <div class="col-12 col-md-12 col-lg-3 my-2 firstInput">
                  <app-mobile-input
                    (inputClick)="openDepartAirport(depart)"
                    [isNotValid]="searchbox.searchBoxValidation(i)"
                  >
                    <input
                      [ngStyle]="{ display: 'none' }"
                      formControlName="departing"
                      #firstD
                      #mobileIssuedCountryDepart
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('departing')?.value
                          ? onCitySearch(item.get('departing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />

                    <p class="cityInputPlacholder">
                      {{ "searchbox.leaveFrom" | translate }}
                    </p>

                    <div
                      class="airport"
                      *ngIf="sharedService.departingAirports[i]"
                    >
                      <span class="airport__city-name">
                        {{ sharedService.departingAirports[i][sharedService.lang].cityName }}
                      </span>

                      <span class="airport__airport-name">
                        {{ sharedService.departingAirports[i][sharedService.lang].airportName }}
                      </span>
                    </div>

                    <div
                      class="airport"
                      *ngIf="!sharedService.departingAirports[i]"
                    >
                      <span class="airport__city-name">
                        {{ "searchbox.fromAirport" | translate }}
                      </span>
                    </div>
                  </app-mobile-input>

                  <div
                    class="switchArrow"
                    (click)="searchbox.switchDestination(item, i)"
                  >
                    <img
                      src="assets/icons/switch-icon-mobile.svg"
                      [ngStyle]="{ borderColor: 'transparent' }"
                    />
                  </div>
                </div>
              </ng-template>
              <ng-template #depart let-modal>
                <div class="modal-header">
                  <div class="row d-flex justify-content-between p-3">
                    <div class="col-6 modal-header-text">
                      {{
                        translate.currentLang == "en"
                          ? "Leaving from"
                          : "المغادرة من"
                      }}
                    </div>

                    <button
                      type="button"
                      class="btn-close m-0"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    ></button>
                  </div>
                  <div class="row mt-2">
                    <input
                      onClick="this.select();"
                      formControlName="departing"
                      id="departInput"
                      type="text"
                      class="form-control modal-input"
                      aria-label="City"
                      (input)="onSearchInputChange($event)"
                      matInput
                      #firstD
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('departing')?.value
                          ? onCitySearch(item.get('departing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <!-- Depart Airports -->

                  <ng-container *ngIf="sharedService.cities != undefined">
                    <ng-container *ngIf="isSearching; else recommendedAirports">
                      <app-skeleton-airport-list
                        *ngIf="isLoading"
                      ></app-skeleton-airport-list>
                      <ng-container *ngIf="!isLoading">
                        <mat-option
                          *ngFor="
                            let city of sharedService.cities
                              | filterCity: item.get('departing')?.value : sharedService.lang
                              | limitTo: 5
                          "
                          [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                          (click)="
                            assignCountriesForMobileD(
                              city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                              i,
                              city
                            )
                          "
                        >
                          <div class="airportFormat">
                            <span class="me-2"
                              ><img
                                src="../../../../../assets/images/depart-icon.png"
                                width="30px"
                              />
                            </span>
                            <span class="code">
                              (
                              <span
                                [innerHTML]="
                                  city[sharedService.lang].airportCode
                                    | highlighter: item.get('departing')?.value
                                "
                              ></span>
                              )
                            </span>
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportName
                                  | highlighter: item.get('departing')?.value
                              "
                            ></span>
                            -
                            <span
                              [innerHTML]="
                                city[sharedService.lang].countryName
                                  | highlighter: item.get('departing')?.value
                              "
                            ></span>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>

                    <ng-template #recommendedAirports>
                      <div class="title ms-2">
                        <span class="me-2">
                          <img
                            src="../../../../../assets/images/destination.png"
                            width="30px" /></span
                        >{{
                          translate.currentLang == "en"
                            ? "Popular Destinations"
                            : " وجهات مشهورة"
                        }}
                      </div>
                      <mat-option
                        *ngFor="let city of getRecommendedAirports()"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileD(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/depart-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('departing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-template>
              <!-- Land City  for web -->
              <div
                *ngIf="sharedService.screenWidth >= 650; else airportsLandingMobileView"
                class="col-12 col-md-12 col-lg-3"
              >
                <mat-form-field
                  color="accent"
                  class="searchboxInput"
                  appearance="outline"
                >
                  <p
                    class="cityInputPlacholder"
                    [ngStyle]="{
                      color: searchbox.searchBoxValidation(i) ? 'red' : '',
                    }"
                  >
                    <ng-container *ngIf="searchbox.searchBoxValidation(i)"
                      >*</ng-container
                    >
                    {{ "searchbox.goingTo" | translate }}
                  </p>
                  <!-- Land Inputs -->
                  <div class="d-flex">
                    <input
                      onClick="this.select();"
                      formControlName="landing"
                      type="text"
                      class="input"
                      aria-label="City"
                      matInput
                      [matAutocomplete]="autob"
                      #firstAr
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('landing')?.value
                          ? onCitySearch(item.get('landing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                    <i
                      class="bi bi-x closeIcon"
                      (click)="firstAr.value = ' '; removeInput('land', i)"
                    ></i>
                  </div>
                  <!-- Land Airports -->
                  <mat-autocomplete #autob="matAutocomplete">
                    <ng-container *ngIf="sharedService.cities != undefined">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('landing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        (onSelectionChange)="onSelectLandingCity(city, i)"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                      >
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportName
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        -
                        <span
                          [innerHTML]="
                            city[sharedService.lang].countryName
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        (
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportCode
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        )
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <ng-template #airportsLandingMobileView>
                <div class="col-12 col-md-12 col-lg-4 firstInput">
                  <input
                    [ngStyle]="{ display: 'none' }"
                    formControlName="landing"
                    #firstD
                    #mobileIssuedCountryLanding
                    (input)="onCitySearch($event)"
                    (focus)="
                      item.get('landing')?.value
                        ? onCitySearch(item.get('landing')?.value)
                        : (sharedService.cities = getRecommendedAirports())
                    "
                  />

                  <app-mobile-input
                    class="col-6"
                    (inputClick)="openLandingAirport(landing)"
                    [isNotValid]="searchbox.searchBoxValidation(i)"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.goingTo" | translate }}
                    </p>

                    <div
                      class="airport"
                      *ngIf="sharedService.landingAirports[i]"
                    >
                      <span class="airport__city-name">
                        {{ sharedService.landingAirports[i][sharedService.lang].cityName }}
                      </span>

                      <span class="airport__airport-name">
                        {{ sharedService.landingAirports[i][sharedService.lang].airportName }}
                      </span>
                    </div>

                    <div
                      class="airport"
                      *ngIf="!sharedService.landingAirports[i]"
                    >
                      <span class="airport__city-name">
                        {{ "searchbox.toAirport" | translate }}
                      </span>
                    </div>
                  </app-mobile-input>
                </div>
              </ng-template>
              <ng-template #landing let-modal>
                <div class="modal-header">
                  <div class="row d-flex justify-content-between p-3">
                    <div class="col-6 modal-header-text">
                      {{
                        translate.currentLang == "en"
                          ? "Going to"
                          : "الوصول الى"
                      }}
                    </div>

                    <button
                      type="button"
                      class="btn-close m-0"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    ></button>
                  </div>
                  <div class="row mt-2">
                    <input
                      onClick="this.select();"
                      formControlName="landing"
                      id="landingInput"
                      type="text"
                      class="form-control modal-input"
                      aria-label="City"
                      matInput
                      #firstD
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('landing')?.value
                          ? onCitySearch(item.get('landing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <!--landing Airports -->
                  <ng-container *ngIf="sharedService.cities != undefined">
                    <ng-container *ngIf="isSearching; else recommendedAirports">
                      <app-skeleton-airport-list
                        *ngIf="isLoading"
                      ></app-skeleton-airport-list>
                      <ng-container *ngIf="!isLoading">
                        <mat-option
                          *ngFor="
                            let city of sharedService.cities
                              | filterCity: item.get('landing')?.value : sharedService.lang
                              | limitTo: 5
                          "
                          [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                          (click)="
                            assignCountriesForMobileA(
                              city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                              i,
                              city
                            )
                          "
                        >
                          <div class="airportFormat">
                            <span class="me-2"
                              ><img
                                src="../../../../../assets/images/landing-icon.png"
                                width="30px"
                              />
                            </span>
                            <span class="code">
                              (
                              <span
                                [innerHTML]="
                                  city[sharedService.lang].airportCode
                                    | highlighter: item.get('landing')?.value
                                "
                              ></span>
                              )
                            </span>
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportName
                                  | highlighter: item.get('landing')?.value
                              "
                            ></span>
                            -
                            <span
                              [innerHTML]="
                                city[sharedService.lang].countryName
                                  | highlighter: item.get('landing')?.value
                              "
                            ></span>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>

                    <ng-template #recommendedAirports>
                      <div class="title ms-2">
                        <span class="me-2">
                          <img
                            src="../../../../../assets/images/destination.png"
                            width="30px" /></span
                        >{{
                          translate.currentLang == "en"
                            ? "Popular Destinations"
                            : " وجهات مشهورة"
                        }}
                      </div>
                      <mat-option
                        *ngFor="let city of getRecommendedAirports()"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileA(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/landing-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('landing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-template>
              <!-- Depart Date Input -->
              <div
                class="col-12 col-lg-2"
                *ngIf="sharedService.screenWidth >= 650; else dateElseCondition"
                (click)="showDate(i)"
              >
                <div 
                  *ngIf="i == 0"
                  [matMenuTriggerFor]="multiCityCalender"
                  #multiCityCalenderTrigger_0
                >
                  <mat-form-field
                    class="searchboxInput"
                    appearance="outline"
                    color="accent"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.depart" | translate }}
                    </p>
                    <input
                      *ngIf="
                        searchbox.flightsArray.at(i).get('departingD')!.value !=
                        null
                      "
                      [id]="'multiCityCalenderTrigger_' + i"
                      readonly
                      matInput
                      
                      type="text"
                      value="{{
                        searchbox.flightsArray.at(i).get('departingD')!.value
                          | date: 'MMM dd'
                      }}"
                    />
                  </mat-form-field>
                </div>

                <div 
                  *ngIf="i == 1"
                  [matMenuTriggerFor]="multiCityCalender"
                  #multiCityCalenderTrigger_1
                >
                  <mat-form-field
                    class="searchboxInput"
                    appearance="outline"
                    color="accent"
                    *ngIf="i == 1"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.depart" | translate }}
                    </p>
                    <input
                      *ngIf="
                        searchbox.flightsArray.at(i).get('departingD')!.value !=
                        null
                      "
                      readonly
                      matInput
                      [id]="'multiCityCalenderTrigger_' + i"
                      type="text"
                      value="{{
                        searchbox.flightsArray.at(i).get('departingD')!.value
                          | date: 'MMM dd'
                      }}"
                    />
                  </mat-form-field>
                </div>

                <div 
                  *ngIf="i == 2"
                  [matMenuTriggerFor]="multiCityCalender"
                  #multiCityCalenderTrigger_2
                >
                  <mat-form-field
                    class="searchboxInput"
                    color="accent"
                    appearance="outline"
                    *ngIf="i == 2"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.depart" | translate }}
                    </p>
                    <input
                      *ngIf="
                        searchbox.flightsArray.at(i).get('departingD')!.value !=
                        null
                      "
                      readonly
                      matInput
                      [id]="'multiCityCalenderTrigger_' + i"
                      type="text"
                      value="{{
                        searchbox.flightsArray.at(i).get('departingD')!.value
                          | date: 'MMM dd'
                      }}"
                    />
                  </mat-form-field>
                </div>

                <div 
                  *ngIf="i == 3"
                  [matMenuTriggerFor]="multiCityCalender"
                  #multiCityCalenderTrigger_3
                >
                  <mat-form-field
                    class="searchboxInput"
                    color="accent"
                    appearance="outline"
                    *ngIf="i == 3"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.depart" | translate }}
                    </p>
                    <input
                      *ngIf="
                        searchbox.flightsArray.at(i).get('departingD')!.value !=
                        null
                      "
                      readonly
                      matInput
                      [id]="'multiCityCalenderTrigger_' + i"
                      type="text"
                      value="{{
                        searchbox.flightsArray.at(i).get('departingD')!.value
                          | date: 'MMM dd'
                      }}"
                    />
                  </mat-form-field>
                </div>
              </div>
              <!-- Date Else Condition -->
              <ng-template #dateElseCondition>
                <app-mobile-input
                  class="col-12 mt-2"
                  (inputClick)="showMobileDate(i - 0)"
                >
                  <p class="cityInputPlacholder">
                    {{ "searchbox.depart" | translate }}
                  </p>

                  <p
                    class="fs-6"
                    *ngIf="
                      searchbox.flightsArray.at(i).get('departingD')?.value
                    "
                  >
                    {{
                      searchbox.flightsArray.at(i).get("departingD")?.value
                        | date: "MMM dd"
                    }}
                  </p>

                  <p
                    class="fs-6"
                    *ngIf="
                      !searchbox.flightsArray.at(i).get('departingD')?.value
                    "
                  >
                    {{ "searchbox.depDate" | translate }}
                  </p>
                </app-mobile-input>
              </ng-template>
              <!-- Travelers/Class -->
              <ng-container *ngIf="i == 0">
                <div
                  class="col-12 col-md-12 col-lg-2"
                  (click)="showTravellers(i)"
                  *ngIf="sharedService.screenWidth >= 650; else travelerElseCondition"
                >
                  <mat-form-field
                    class="searchboxInput"
                    appearance="outline"
                    color="accent"
                    [matMenuTriggerFor]="menu"
                    (click)="openClass = true"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.traveller" | translate }}
                    </p>
                    <input
                      matInput
                      readonly
                      type="text"
                      value="{{
                        getTotalPassenger() +
                          '/' +
                          (searchbox.searchFlight.controls['class'].value
                            | translate)
                      }}"
                    />
                  </mat-form-field>
                </div>

                <!-- Travelers/Class Else Condition -->
                <ng-template #travelerElseCondition>
                  <app-mobile-input
                    class="col-12 my-2"
                    (inputClick)="showTravellers(i); openClass = true"
                    [matMenuTriggerFor]="menu"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.traveller" | translate }}
                    </p>

                    <p class="fs-6">
                      {{
                        getTotalPassenger() +
                          "/" +
                          (searchbox.searchFlight.controls["class"].value
                            | translate)
                      }}
                    </p>
                  </app-mobile-input>
                </ng-template>

                <ng-container *ngIf="sharedService.screenWidth >= 992">
                  <div
                    class="col-12 col-md-12 col-lg-2 button-in-result"
                    *ngIf="InFlightResult()"
                  >
                    <button class="submit-btn" (click)="submit()">
                      {{ "searchbox.search" | translate }}
                    </button>
                  </div>

                  <!--Submit Button -->
                  <div
                    class="col-12 col-md-12 col-lg-2 submitBtn"
                    *ngIf="!InFlightResult()"
                  >
                    <button class="submit-btn mt-2" (click)="submit()">
                      {{ "searchbox.search" | translate }}
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>

            <mat-menu #multiCityCalender="matMenu" class="calenderMenu">
              <div class="datesSummary" (click)="$event.stopPropagation()">
                <div class="dateSummaryBox">
                  <!-- <span>{{ "searchFlight.Today" | translate }}</span> -->
                  <!-- <span class="dateSummaryValue" [ngClass]="{
                      'dateSummaryValueAR': translate.currentLang=='ar'
                    }">{{
                      searchbox.flightsArray.at(0).get('departingD')?.value
                      | date : 'MMM dd'                      }}</span> -->
                </div>
              </div>
              <ngb-datepicker
                class="searchBoxPicker"
                [displayMonths]="1"
                (click)="$event.stopPropagation()"
                navigation="arrows"
                [dayTemplate]="onwwayDAY"
                outsideDays="hidden"
                [minDate]="minDate"
              >
              </ngb-datepicker>

              <ng-template
                #onwwayDAY
                let-date
                let-focused="focused"
                (click)="$event.stopPropagation()"
              >
                <span
                  class="custom-day"
                  (click)="$event.stopPropagation()"
                  (click)="onDateSelection(date, i)"
                  [class.range]="isRange(date)"
                  [class.faded]="isHovered(date) || isInside(date)"
                  [class.disabled]="isDisabled(date)"
                  (mouseenter)="hoveredDate = date"
                  (mouseleave)="hoveredDate = null"
                >
                  {{ date.day | translate }}
                </span>
              </ng-template>
            </mat-menu>

            <ng-container
              *ngIf="
                sharedService.screenWidth < 992 &&
                i === searchbox.flightsArray['controls'].length - 1
              "
            >
              <div
                class="col-12 col-md-12 col-lg-2 button-in-result"
                *ngIf="InFlightResult()"
              >
                <button class="submit-btn" (click)="submit()">
                  {{ "searchbox.search" | translate }}
                </button>
              </div>

              <!--Submit Button -->
              <div
                class="col-12 col-md-12 col-lg-2 submitBtn"
                *ngIf="!InFlightResult()"
              >
                <button class="submit-btn mt-4" (click)="submit()">
                  {{ "searchbox.search" | translate }}
                </button>
              </div>
            </ng-container>

            <hr class="mt-2" *ngIf="sharedService.screenWidth < 992" />

            <!-- ADD & REMOVE FLIGHTS BUTTONS-->
            <div
              class="col-12 col-md-4 col-lg-1 multi-buttons"
              *ngIf="i === searchbox.flightsArray['controls'].length - 1"
            >
              <button
                mat-icon-button
                color="accent"
                type="button"
                class="morebtn float-end"
                (click)="addFlight()"
              >
                <mat-icon>add_circle</mat-icon>
              </button>
              <button
                mat-icon-button
                color="accent"
                type="button"
                class="morebtn float-end"
                (click)="removeFlight()"
                *ngIf="searchbox.flightsArray.length > 1"
              >
                <mat-icon>remove_circle</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</div>
<!-- Travellers menu -->
<mat-menu #menu="matMenu">
  <div class="travellersAndClassMenu">
    <form [formGroup]="searchbox.searchFlight">
      <ng-container formGroupName="passengers">
        <div class="travel" (click)="stopMenuClosing($event)">
          <div class="travellersTypes" (click)="$event.stopPropagation()">
            <div class="type">
              <div class="typeText">
                {{ "searchbox.adults" | translate }}
                <p class="subT">{{ "searchbox.adultsNum" | translate }}</p>
              </div>
              <div class="typeControl">
                <span class="decreaseBtn" (click)="changeAdultValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers")?.get("adults")?.value
                }}</span>
                <span class="increaseBtn" (click)="changeAdultValue('increase')"
                  >+</span
                >
              </div>
            </div>

            <div class="type">
              <div class="typeText">
                {{ "searchbox.children" | translate }}
                <p class="subT">{{ "searchbox.childrenNum" | translate }}</p>
              </div>

              <div class="typeControl">
                <span class="decreaseBtn" (click)="changeChildValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers.child")?.value
                }}</span>
                <span class="increaseBtn" (click)="changeChildValue('increase')"
                  >+</span
                >
              </div>
            </div>

            <div class="type">
              <div class="typeText">
                {{ "searchbox.infants" | translate }}
                <p class="subT">{{ "searchbox.infantsNum" | translate }}</p>
              </div>

              <div class="typeControl">
                <span
                  class="decreaseBtn"
                  (click)="changeInfantValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers.infant")?.value
                }}</span>
                <span
                  class="increaseBtn"
                  (click)="changeInfantValue('increase')"
                  >+</span
                >
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <mat-form-field
        *ngIf="openClass"
        color="accent"
        appearance="outline"
        (click)="$event.stopPropagation()"
      >
        <!-- <mat-label>{{"searchFlight.class"|translate}}</mat-label> -->
        <mat-select formControlName="class" value="Economy">
          <mat-option
            value="Economy"
            selected
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.economy" | translate }}
          </mat-option>

          <mat-option
            value="Business"
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.business" | translate }}
          </mat-option>
          <mat-option
            value="First"
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.first" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-menu>
